{"locales":["en","es","pt","fr","de","it","pl","sv"],"defaultLocale":"en"}